import { Component, OnInit } from '@angular/core';
import { DataApiService } from 'src/app/Services/data-api.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertRefreshComponent } from '../alert-refresh/alert-refresh.component';
import {FileUploadService} from './../../../Services/file-upload.service';

@Component({
  selector: 'app-crear-usuarios-mototizados',
  templateUrl: './crear-usuarios-mototizados.component.html',
  styleUrls: ['./crear-usuarios-mototizados.component.scss']
})
export class CrearUsuariosMototizadosComponent implements OnInit {

  constructor(
    private dataApi :DataApiService,
    private dialog: MatDialog,
    private fileUploadService: FileUploadService,

  ) { }

  public form = {
    name: null,
    surname:null,
    codigo_motorizado: null,
    placa_moto:null,
    telefono: null,
    usuario: null,
    password: null,
    password_confirmation: null,
    file_name:null,
    base64textString:null,
    type:"user"
  }
  error_image:boolean = false;

  saveImage:any = null;

  crearUsuarioMotorizado(){
    if(this.form.file_name!=null && this.form.base64textString !=null){
      this.error_image=false;
      this.dataApi.crearUsuarioMotorizado(this.form).subscribe(
        data  => this.handleResponse(data),
        error => console.log(error)
      )
      this.fileUploadService.uploadFile(this.form).subscribe();
     

    }else{
      this.error_image= true;
    }      
  }
  handleResponse(data){
    this.dialog.closeAll(); 
    this.dialog.open(AlertRefreshComponent,{
      width:"200px",   
      data:{mensaje:"El usuario Motorizado ha sido creado con éxito"},
      disableClose: false,
      autoFocus:true
    });     
  }
  filePreview(input){
    if(input.files && input.files[0]){
      const reader = new FileReader();
      reader.onload = (event)=>{
        document.getElementById("filePreview").innerHTML = `<img src="${event.target["result"]}" style="width:150px"/>`;
      }
      reader.readAsDataURL(input.files[0]);
    }
  }
  seleccionarArchivo(event){
    const files = event.target.files;
    const file = files[0]; 
    this.saveImage = file;   
    this.form.file_name = "user-"+event.target.files[0].name ;
    if(files && file){
      var reader = new FileReader();
      reader.onload= this._handleReaderLoadad.bind(this);      
      
      reader.readAsBinaryString(file)
    }
  }

  _handleReaderLoadad(readerEvent){
    const binaryString = readerEvent.target.result;   
    
    this.form.base64textString = btoa(binaryString)
  }
  
  ngOnInit() {
    const file = document.getElementById("file");
    file.addEventListener("change",()=>{
    this.filePreview(file);
   })
  }

}
